import { useState } from "react";
import { FaCommentAlt } from "react-icons/fa";

function MessageBox() {
  const [showNotification, setShowNotification] = useState(false);

  const toggleNotification = () => {
    setShowNotification((prev) => !prev);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '40px', position: 'relative' }}>
      {/* Icon with click handler */}
      <div onClick={toggleNotification} style={{ cursor: 'pointer' }}>
        <FaCommentAlt />
      </div>

      {/* Notification Box with updated styles */}
      {showNotification && (
        <div style={{
          position: 'absolute',
          top: '40px',
          left: '0',
          backgroundColor: '#007bff', // Blue background
          padding: '15px 20px', // More padding for better look
          border: '1px solid #0056b3', // Darker blue border
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', // Slightly bigger shadow for depth
          zIndex: 100,
          color: '#fff', // White text for contrast
          fontWeight: 'bold', // Bold text for better readability
        }}>
          <p>This is your notification box.</p>
        </div>
      )}
    </div>
  );
}

export default MessageBox;
